export default __webpack_public_path__ + "static/media/bank-transfer.615b064b.svg";